<!--
 * @Description:潜在客户
 * @Author: cxh
 * @Date: 2022-06-10 13:33:54
 * @LastEditTime: 2023-06-21 09:45:25
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <a-tabs v-model:activeKey="queryForm.dataPermissionType" @change="search">
        <a-tab-pane :key="undefined" tab="全部"></a-tab-pane>
        <a-tab-pane :key="1" tab="我的客户" force-render></a-tab-pane>
        <a-tab-pane :key="2" tab="下属的客户"></a-tab-pane>
      </a-tabs>
      <cos-table
        rowKey="cosId"
        :row-selection="{ onChange: onSelectChange }"
        serials
        :columns="columns"
        tableId="fbuClients"
        @fetch="fetch"
        @mask="showMask"
        v-model:search="queryForm"
        ref="tableRef"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item label="成交客户状态">
              <a-select
                v-model:value="queryForm.status"
                allowClear
                placeholder="请选择"
                mode="multiple"
                :options="clientsStatusEnum"
              />
            </dc-form-item>
            <dc-form-item label="客户名称">
              <a-input v-model:value="queryForm.customerName" allowClear placeholder="请输入"/>
            </dc-form-item>
            <dc-form-item label="剩余跟进天数">
              <a-select
                v-model:value="queryForm.remanentFollowDayType"
                allowClear
                placeholder="请选择"
                :options="remanentFollowDayTypeEnum"
              />
            </dc-form-item>
            <dc-form-item label="档次">
              <a-select
                v-model:value="queryForm.level"
                allowClear
                :fieldNames="{ label: 'configName', value: 'id' }"
                placeholder="请选择"
                :options="level"
              />
            </dc-form-item>
            <dc-form-item label="子客户代码">
              <a-input v-model:value="queryForm.arkCode" allowClear placeholder="请输入"/>
            </dc-form-item>
            <dc-form-item label="联系方式">
              <a-input-group compact>
                <a-select v-model:value="queryForm.contact.type" style="width: 33%" placeholder="请选择">
                  <a-select-option :value="1">手机号</a-select-option>
                  <a-select-option :value="3">邮箱</a-select-option>
                  <a-select-option :value="4">微信号</a-select-option>
                  <a-select-option :value="5">qq</a-select-option>
                  <a-select-option :value="2">固定电话</a-select-option>
                </a-select>
                <a-input v-model:value="queryForm.contact.keyword" style="width: 67%" placeholder="请输入"/>
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="客户负责人">
              <user-select v-model:value="queryForm.seller"/>
            </dc-form-item>
            <dc-form-item label="客户评级">
              <a-select v-model:value="queryForm.grade" placeholder="请选择" allowClear :options="customerGradeEnum"/>
            </dc-form-item>
            <dc-form-item label="领取时间">
              <cos-range-picker v-model:startTime="queryForm.receiveStart" v-model:endTime="queryForm.receiveEnd"/>
            </dc-form-item>
            <dc-form-item label="转成交时间">
              <cos-range-picker
                v-model:startTime="queryForm.turnedTransactionStart"
                v-model:endTime="queryForm.turnedTransactionEnd"
              />
            </dc-form-item>
            <dc-form-item label="客户ID">
              <a-input v-model:value="queryForm.cosId" :maxlength="500" allowClear placeholder="请输入"/>
            </dc-form-item>
            <dc-form-item label="排序">
              <a-select
                v-model:value="queryForm.sortCollection"
                :options="favoriteStatus"
                placeholder="请选择"
                allowClear
              />
            </dc-form-item>
            <dc-form-item label="未跟进天数">
              <a-select
                v-model:value="queryForm.unfollowDayType"
                allowClear
                placeholder="请选择"
                :options="customerUnfollowDayTypeEnum"
              />
            </dc-form-item>
            <dc-form-item label="成交金额(万)">
              <div class="flex" style="align-items: center">
                <a-input-number
                  v-model:value="queryForm.minTurnoverAmount"
                  :min="0"
                  :controls="false"
                  placeholder="请输入"
                />
                <p style="margin: 0 5px" class="line"></p>
                <a-input-number
                  v-model:value="queryForm.maxTurnoverAmount"
                  :min="0"
                  :controls="false"
                  placeholder="请输入"
                />
              </div>
            </dc-form-item>
            <dc-form-item label="来源渠道">
              <a-input-group compact>
                <ParamCodeCascader
                  type="search"
                  v-model:ids="queryForm.channelList"
                  appId="cos_fbu"
                  paramCode="fbu_source_channel"
                  style="width: 33%"
                />
                <a-input
                  v-model:value="queryForm.channelExplain"
                  :maxlength="100"
                  style="width: 67%"
                  placeholder="请输入"
                  allowClear
                />
              </a-input-group>
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record, text,index }">
          <template v-if="column.dataIndex === 'customerName'">
            <div class="flex">
              <favorite-icon type="add" v-if="record.collectionId===null"  @click="addFavorite(record,index)"/>
              <favorite-icon type="cancel" v-else  @click="cancelFavorite(record,index)" />
              <p class="time-out-flag" v-if="record.timeoutFlag === true">超时</p>
              <p class="new-list-flag" v-if="record.haveFollowFlag === false">New</p>
              <p class="black-list-flag" v-if="record.blackListFlag">黑名单</p>
              <router-link
                :to="`/fbu/clients/view?cosId=${record.cosId}`"
                class="ant-table-cell-ellipsis"
                :title="text"
              >{{ text || '--' }}
              </router-link
              >
            </div>
          </template>
          <template v-if="column.dataIndex === 'channel'">
            <ChannelText appId="cos_fbu" paramCode="fbu_source_channel" :value="text" :desc="record.channelExplain"/>
          </template>
          <template v-if="column.dataIndex === 'customerRegion'">
            <CustomerAreaCascaderText appId="cos_fbu" :value="text"/>
          </template>
          <template v-if="column.dataIndex === 'arkCode'">
            <p>{{ Array.isArray(text) && text.length > 0 ? text.join('、') : '--' }}</p>
          </template>
          <template v-if="column.dataIndex === 'status'">
            <dc-status :enums="statusEnum" :value="text"/>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="handleSendLink(record)" v-permission="'fbu_clients_send_link_btn'"
              >发送注册链接
              </a-button
              >
              <a-button
                type="link"
                @click="handleFollowUp(record)"
                v-show="!record.blackListFlag"
                v-permission="'fbu_clients_follow_add_btn'"
              >写跟进
              </a-button
              >
              <a-button type="link" @click="hanleAddVisitor(record)" v-permission="'fbu_clients_visitor_add_btn'"
              >新增访客计划
              </a-button
              >
              <SellerButton
                type="link"
                :workCode="record.seller"
                @click="handleAddBuss(record)"
                v-permission="'fbu_clients_buss_add_btn'"
              >新增商机
              </SellerButton
              >
              <a-button
                type="link"
                @click="handleAddCode(record)"
                v-show="!record.blackListFlag"
                v-permission="'fbu_clients_code_add_btn'"
              >新增客户代码
              </a-button
              >
              <a-button
                type="link"
                @click="handleRelationCode(record)"
                v-show="!record.blackListFlag"
                v-permission="'fbu_clients_code_relative_btn'"
              >关联客户代码
              </a-button
              >
              <a-button
                type="link"
                v-show="record.status === 22 || record.status === 36"
                v-permission="'fbu_clients_loss_active_btn'"
                @click="activation(record)"
              >流失激活
              </a-button
              >
              <a-button type="link" @click="handleEdit(record)" v-permission="'fbu_clients_edit_btn'">编辑</a-button>
              <a-button type="link" @click="handleDelete(record)" v-permission="'fbu_clients_del_btn'">删除</a-button>
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="handleTransfer()" v-permission="'fbu_clients_transfer_btn'"
          >转移客户
          </a-button
          >
          <CosMergeButton
            v-permission="'fbu_clients_customer_aggregation_merge_btn'"
            :data="selectedRows"
            appId="cos_fbu"
            :fbuType="4"
            @success="success"
          >合并
          </CosMergeButton
          >
          <ExportButton appId="cos_fbu" taskType="205" :search="queryForm" v-permission="'fbu_clients_export_btn'"
          >导出
          </ExportButton
          >
          <a-button v-permission="'fbu_clients_export_details_btn'" @click="handleExportDetails()">导出明细</a-button>
        </template>
      </cos-table>
      <!--发送注册链接--->
      <sendLinkModel ref="sendLinkModelRef"/>
      <!--新增客户代码--->
      <addCodeModel ref="addCodeModelRef" @success="success"/>
      <!--关联客户代码--->
      <relationCode ref="relationCodeRef" @success="success"/>
      <!--转移客户--->
      <transferModel ref="transferModelRef" @success="success"/>

      <!-- 导出明细 -->
  <ExportDetails ref="exportDetailsRef" appId="cos_fbu" :search="queryForm" :taskTypeEnum="[
  { value: 217, label: '签到地址' },
  { value: 221, label: '在售平台' },
  { value: 225, label: '需求海外仓' }
]"/>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { reactive, computed, onMounted, ref } from 'vue'
import { potentialList, potentialDel, potentialDetail } from '@/api/gucangSales/customerCenter'
import {
  customerGradeEnum,
  clientsStatusEnum,
  genderEnum,
  linkRoleTypeEnum,
  customerTypeEnum,
  flagEnum,
  remanentFollowDayTypeEnum,
  customerUnfollowDayTypeEnum,
  favoriteStatus
} from '@/views/gucangSales/commonEnum/dataConfig'
import relationCode from '../components/relationCode/index.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import addCodeModel from '@/views/gucangSales/customerCenter/accountCode/editModal.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import sendLinkModel from '../components/sendLinkModel.vue'
import transferModel from '../components/transferModel.vue'
import ExportDetails from '@/views/gucangSales/clueManage/salesClue/components/ExportDetails.vue'
import CosMergeButton from '@/components/CosMergeButton'
import { addToFav, cancelToFav, getLevelOrGrade, listByParamCodes } from '@/api/common'
import { useRouter, useRoute } from 'vue-router'
import { DcMessage } from '@dc-platform/dc-components'
import DCModal from '@/hooks/modalType'
import type { PotentialItem } from '@/typings/api/customerCenter'
import FavoriteIcon from '@/components/FavoriteIcon/index.vue'

const router = useRouter()
const route = useRoute()

const tableRef = ref()
const sendLinkModelRef = ref()
const addCodeModelRef = ref()
const relationCodeRef = ref()
const transferModelRef = ref()
const selectedRows = ref<PotentialItem[]>([])
const level = ref([])

const exportDetailsRef = ref()
const handleExportDetails = () => {
  exportDetailsRef.value?.init()
}

const queryForm = ref<{
  level?: any[]
  dataPermissionType?: number
  contact: any
  stage: number
  grad?: number
  levelList?: any[]
  sortCollection: number,
  gradList?: any[]
}>({
  dataPermissionType: undefined,
  contact: {
    type: 1
  },
  sortCollection: 1,
  stage: 4 // 2 潜在 3签约 4成交
})
const paramCodeData = reactive<{
  fbu_sales_category: []
  fbu_product_type: []
  fbu_warehouse: []
  fbu_sale_platform: []
  fbu_service_demand: []
  fbu_demand_info: []
  fbu_erp_info: []
  fbu_replenish_frequency: []
  fbu_business_type: []
  fbu_marketing_activity: []
  fbu_customer_size: []
  fbu_industrial_belt: []
  fbu_customer_category: []
}>({
  fbu_sales_category: [], // 销售品类
  fbu_product_type: [], // 货物类型
  fbu_warehouse: [], // 合作海外仓
  fbu_sale_platform: [], // 在售电商平台
  fbu_service_demand: [], // 服务需求
  fbu_demand_info: [], // 需求海外仓
  fbu_erp_info: [], // 目前使用ERP
  fbu_replenish_frequency: [], // 头程补货频次
  fbu_business_type: [], // 客户业务类型
  fbu_marketing_activity: [], // 关联市场活动
  fbu_customer_size: [], // 关联市场活动
  fbu_industrial_belt: [], // 产业带
  fbu_customer_category: [] // 客户类别
})
onMounted(() => {
  getByParamCodes()
  fetchLevel()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: [
      'fbu_sales_category',
      'fbu_product_type',
      'fbu_warehouse',
      'fbu_sale_platform',
      'fbu_service_demand',
      'fbu_demand_info',
      'fbu_erp_info',
      'fbu_replenish_frequency',
      'fbu_business_type',
      'fbu_marketing_activity',
      'fbu_customer_size',
      'fbu_industrial_belt',
      'fbu_customer_category'
    ]
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const fetchLevel = () => {
  getLevelOrGrade({
    configType: 1,
    appId: 'cos_fbu'
  }).then((res) => {
    level.value = res.data
  })
}
// 获取列表
const fetch = (params: object, callBack: (res: any) => void) => {
  // 重组档次搜索
  const levelList: { min: number; max: number }[] = []
  if (queryForm.value.level) {
    const obj: any = level.value.find((v: any) => queryForm.value.level === v.id)
    if (obj) {
      levelList.push({
        min: obj.min,
        max: obj.max
      })
    }
  }
  queryForm.value.levelList = levelList
  potentialList({
    ...params,
    levelList
  }).then((res) => {
    callBack(res)
  })
}
// 获取掩码信息
const showMask = (record: PotentialItem, callBack: (res: any) => void) => {
  potentialDetail(record.cosId).then((res) => {
    callBack(res.data.contact)
  })
}
const search = () => {
  tableRef.value.search()
}
const onSelectChange = (selectedRowKeys: string[], rows: PotentialItem[]) => {
  selectedRows.value = rows
}
// 转移客户
const handleTransfer = () => {
  transferModelRef.value.toggle(selectedRows.value)
}
// 删除
const handleDelete = (row: PotentialItem) => {
  DCModal.delete({
    content: `删除【${row.customerName}】，会同步删除该客户相关的商机、访客计划、跟进记录，且删除操作无法恢复，请谨慎操作。`,
    onOk() {
      potentialDel({ cosIdList: [row.cosId] }).then(() => {
        DcMessage.success('删除成功')
        tableRef.value.delFetch()
      })
    }
  })
}
// 关联客户代码
const handleRelationCode = (row: PotentialItem) => {
  relationCodeRef.value.toggle(row)
}
// 新增关联代码
const handleAddCode = (row: PotentialItem) => {
  addCodeModelRef.value.toggle({
    cosId: row.cosId
  })
}
// 编辑
const handleEdit = (row: PotentialItem) => {
  router.push({
    path: '/fbu/clients/edit',
    query: {
      cosId: row.cosId
    }
  })
}
// 新增访客计划
const hanleAddVisitor = (row: PotentialItem) => {
  router.push({
    path: '/fbu/visitorProgram/add',
    query: {
      saleChanceRefId: row.cosId
    }
  })
}
// 写跟进
const handleFollowUp = (row: PotentialItem) => {
  router.push({
    path: '/fbu/followUpRecord/add',
    query: {
      followRefId: row.cosId,
      returnPath: route.fullPath
    }
  })
}
// 写商机
const handleAddBuss = (row: PotentialItem) => {
  router.push({
    path: '/fbu/business/add',
    query: {
      saleChanceRefId: row.cosId
    }
  })
}
// 流失激活
const activation = (row: PotentialItem) => {
  router.push({
    path: '/fbu/customerActive',
    query: {
      cosId: row.cosId,
      type: 'clients'
    }
  })
}
// 收藏
const addFavorite = (row: PotentialItem, index:number) => {
  addToFav({
    appId: 'cos_fbu',
    cosId: row.cosId,
    stage: 4
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = row.cosId
      tableRef.value?.notifyItem(index, row)
    }
  })
}
// 收藏
const cancelFavorite = (row: PotentialItem, index:number) => {
  cancelToFav({
    appId: 'cos_fbu',
    cosId: row.cosId,
    stage: 4
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = null
      row.collectionTime = null
      tableRef.value?.notifyItem(index, row)
    }
  })
}
// 发送注册链接
const handleSendLink = (row: PotentialItem) => {
  sendLinkModelRef.value.toggle(row)
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

const statusEnum = clientsStatusEnum.map((item) => ({
  name: item.label,
  value: item.value,
  color: item.color
}))

// 32
const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  {
    title: '客户ID',
    dataIndex: 'cosId',
    width: 200
  },
  {
    title: '主客户代码',
    dataIndex: 'customerNumber'
  },
  {
    title: '来源渠道',
    dataIndex: 'channel',
    width: 150
  },
  {
    title: '成交客户状态',
    dataIndex: 'status'
  },
  {
    title: '客户区域',
    dataIndex: 'customerRegion'
  },
  {
    title: '客户负责人',
    dataIndex: 'sellerName'
  },
  {
    title: '剩余跟进天数',
    dataIndex: 'remanentFollowDays'
  },
  {
    title: '未跟进天数',
    dataIndex: 'unfollowDays'
  },
  {
    title: '最新跟进情况',
    dataIndex: 'followDesc'
  },
  {
    title: '子客户代码',
    dataIndex: 'arkCode'
  },
  {
    title: '联系人姓名',
    dataIndex: ['contact', 'name'],
    cosType: 'mask'
  },
  {
    title: '手机号',
    dataIndex: ['contact', 'mobile'],
    cosType: 'mask'
  },
  {
    title: '微信号',
    dataIndex: ['contact', 'wechat'],
    cosType: 'mask'
  },
  {
    title: '邮箱',
    dataIndex: ['contact', 'email'],
    cosType: 'mask'
  },
  {
    title: 'QQ号',
    dataIndex: ['contact', 'qq'],
    cosType: 'mask'
  },
  {
    title: '固定电话',
    dataIndex: ['contact', 'tel'],
    cosType: 'mask'
  },
  {
    title: '传真号',
    dataIndex: ['contact', 'fax']
  },
  {
    title: '性别',
    dataIndex: ['contact', 'sex'],
    dicData: genderEnum
  },
  {
    title: '角色',
    dataIndex: ['contact', 'jobRole'],
    dicData: linkRoleTypeEnum
  },
  {
    title: '部门职务',
    dataIndex: ['contact', 'jobDuty']
  },
  {
    title: '转成交时间',
    dataIndex: 'turnedTransaction',
    width: 190
  },
  {
    title: '客户类型',
    dataIndex: 'type',
    dicData: customerTypeEnum
  },
  {
    title: '工厂详细地址',
    dataIndex: 'factoryAddress'
  },
  {
    title: '公司详细地址',
    dataIndex: 'customerAddress'
  },
  {
    title: '客户规模',
    dataIndex: 'enterpriseScale',
    dicData: paramCodeData.fbu_customer_size
  },
  {
    title: '客户评级',
    dataIndex: 'grade',
    dicData: customerGradeEnum
  },
  {
    title: '档次',
    dataIndex: 'level'
  },
  {
    title: '成交金额（万）',
    dataIndex: 'turnoverAmount',
    width: 130
  },
  {
    title: '年销售GMV(万)',
    dataIndex: ['business', 'annualSales'],
    width: 140
  },
  {
    title: '销售品类',
    dataIndex: ['business', 'salesCategory'],
    dicData: paramCodeData.fbu_sales_category
  },
  {
    title: '是否供货商',
    dataIndex: ['business', 'supplierFlag'],
    dicData: flagEnum
  },
  {
    title: '是否分销商',
    dataIndex: ['business', 'dealerFlag'],
    dicData: flagEnum
  },
  {
    title: '是否内部客户',
    dataIndex: 'internalCustomersFlag',
    dicData: flagEnum
  },
  {
    title: '需要金融产品',
    dataIndex: ['business', 'financialProductFlag'],
    dicData: flagEnum
  },
  {
    title: '合作海外仓',
    dataIndex: ['business', 'warehouse'],
    dicData: paramCodeData.fbu_warehouse
  },
  {
    title: '货物类型',
    dataIndex: ['business', 'cargoType'],
    dicData: paramCodeData.fbu_product_type
  },
  {
    title: '关联市场活动',
    dataIndex: 'activityId',
    dicData: paramCodeData.fbu_marketing_activity
  },
  {
    title: '是否产业带',
    dataIndex: ['business', 'industrialBeltFlag'],
    dicData: flagEnum
  },
  {
    title: '产业带',
    dataIndex: ['business', 'industrialBelt'],
    dicData: paramCodeData.fbu_industrial_belt
  },
  {
    title: '产业带名称',
    dataIndex: ['business', 'industrialBeltName']
  },
  { title: '客户类别', dataIndex: ['business', 'customerCategory'], dicData: paramCodeData.fbu_customer_category },
  {
    title: '备注',
    dataIndex: 'customerRemark'
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 240,
    fixed: 'right'
  }
])
</script>
<script lang="ts">
export default { name: 'DcCosFbuClients' }
</script>

<style scoped>
.line {
  margin: 0px 7px;
  height: 1px;
  width: 10px;
  background: #ccc;
}
</style>
